import { Dispatch, RefObject, SetStateAction, useEffect, useRef, useState } from 'react';

type UseClickOutsideReturn = {
  ref: RefObject<HTMLDivElement | null>;
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export default function useClickOutside(): UseClickOutsideReturn {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        close();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return { ref, isOpen, open, close, toggle, setIsOpen };
}
